import FolderIcon from '@mui/icons-material/FolderOutlined';
import { Chip, Stack } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(() => ({
    chip: {
        backgroundColor: '#f3f4f6',
        color: '#4b5563',
        fontSize: '12px',
        fontWeight: 500,
        height: '24px',
        borderRadius: 4,
    },
}));

interface FolderChipProps {
    label: string;
}

export const FolderChip: React.FC<FolderChipProps> = ({ label }) => {
    const classes = useStyles();
    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <FolderIcon sx={{ fontSize: 18, color: '#9ca3af' }} />
            <Chip label={label} className={classes.chip} size="small" />
        </Stack>
    );
};
